<div class="hero">
  <div class="hero-content">
    <h1 class="name"></h1>
    <h1 class="name"></h1>
    <h1 class="name"></h1>
    <p class="subtitle"></p>
  </div>
</div>

<style>
  .hero {
    height: 100vh;
    background-image: url('/ImmProvaSitoOtotbre2.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color:white;
    position: relative;
    overflow: hidden;
  }

  .hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(219, 151, 68, 0.05); /*rgba(219, 151, 68, 0.1);*/
  }

  .hero-content {
    position: absolute;
    bottom: 0px; /* Distanza fissa dal fondo */
    left: 0;
    right: 0;
    text-align: center;
    z-index: 1;
  }

  .name {
    font-size: 50px; /* Dimensione fissa in pixel */
    margin: 0;
    line-height: 1.1;
    color: #cf7074;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }

  .subtitle {
    font-size: 24px; /* Dimensione fissa in pixel */
    color: black;
    font-weight: 700;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 5px 10px;
    margin-top: 10px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  @media (max-width: 768px) {

.hero { 
    background-size: cover;
  }

    .hero-content {
      bottom: calc(1vh + 0px);
    }

    .name {
      font-size: calc(3vh + 20px); /* Più piccolo su mobile, ma ancora grande 48px*/
    }

    .subtitle {
      font-size: 18px; /* Leggermente più piccolo su mobile 18px*/
    }
  }
</style>
